import { jsx as k } from "react/jsx-runtime";
import { c as u } from "../index-rKuIKazb.js";
import { useTheme as z } from "../ThemeProvider/index.js";
import '../assets/index11.css';const d = "_layout_13tkm_2", p = "_inline_13tkm_5", g = "_uppercase_13tkm_8", w = "_underline_13tkm_11", f = "_italic_13tkm_14", y = "_dark_13tkm_75", e = {
  layout: d,
  inline: p,
  uppercase: g,
  underline: w,
  italic: f,
  "--size-ant": "_--size-ant_13tkm_17",
  "--size-mouse": "_--size-mouse_13tkm_21",
  "--size-cat": "_--size-cat_13tkm_25",
  "--size-dog": "_--size-dog_13tkm_29",
  "--size-wolf": "_--size-wolf_13tkm_33",
  "--size-bear": "_--size-bear_13tkm_37",
  "--size-giraffe": "_--size-giraffe_13tkm_41",
  "--size-elephant": "_--size-elephant_13tkm_45",
  "--size-whale": "_--size-whale_13tkm_49",
  "--weight-medium": "_--weight-medium_13tkm_53",
  "--weight-bold": "_--weight-bold_13tkm_56",
  "--theme-caviar": "_--theme-caviar_13tkm_59",
  "--theme-granite": "_--theme-granite_13tkm_62",
  "--theme-manatee": "_--theme-manatee_13tkm_65",
  "--theme-secondary": "_--theme-secondary_13tkm_68",
  "--theme-white": "_--theme-white_13tkm_71",
  dark: y
}, N = (m) => {
  const {
    children: s,
    className: a,
    inline: n,
    italic: c,
    size: t = "cat",
    theme: _,
    underline: l,
    uppercase: r,
    weight: i
  } = m, o = z(), h = u(
    e.layout,
    e[o],
    n && e.inline,
    c && e.italic,
    t && e[`--size-${t}`],
    _ && e[`--theme-${_}`],
    l && e.underline,
    r && e.uppercase,
    i && e[`--weight-${i}`],
    a
  );
  return /* @__PURE__ */ k("div", { className: h, children: s });
};
export {
  N as default
};
